import {
  NumberConverter,
  NumberConverterOption,
} from '@marketplace/myconverter';
import classNames from 'classnames';
import { memo } from 'react';

import * as styles from './styles.module.scss';

type FormatNumberProps = {
  value?: number;
  percent?: boolean;
  fractionDigits?: number;
  unit?: React.ReactNode | boolean;
  showPlus?: boolean;
  afterNumber?: React.ReactNode | string;
  variantColor?: 'danger' | 'success';
  className?: string;
  option?: Partial<NumberConverterOption>;
};

function FormatNumber(props: FormatNumberProps) {
  const {
    value = 0,
    unit,
    showPlus,
    afterNumber,
    variantColor,
    className,
    option,
    percent,
  } = props;

  const unitCurrency = () => {
    if (unit && typeof unit === 'boolean') return <span>₫</span>;
    return <div className={styles.otherUnit}>{unit}</div>;
  };

  return (
    <div
      className={classNames(className, styles.displayBlock, {
        "text-danger": variantColor === 'danger',
        "text-success": variantColor === 'success',
      })}
    >
      {unit && unitCurrency()} {showPlus && value > 0 && '+'}
      {NumberConverter.format(value * (percent ? 100 : 1), {
        hideFractionDigits: !percent,
        ...option,
      })}
      {afterNumber}
    </div>
  );
}

export default memo(FormatNumber);
